import {User} from '@drl/core/auth/models/user.model';
import {NameId} from '@drl/core/models';

import {Caregiver} from './caregiver.model';
import {CareGroupUser} from './caregroup-user.model';
import {Patient} from './patient.model';
import { CareGroupCancerTypes } from './care-group-cancer-types.model';

export class CareGroup extends NameId {
  groupImage?: string;
  description?: string;
  members?: User[];
  users?: CareGroupUser[];
  patients?: Patient[];
  caregivers?: Caregiver[];
  cancerType?: string;
  cancerTypeLc?: string;
  specialistId: number;
  belongsToMe?: boolean; // UI Logic
  careGroupCancerTypes:CareGroupCancerTypes[]
  specialist?: User;
}
